<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="isDeletePage() != true ? 'Discount Coupons' : 'Deleted Discount Coupons'"
              ></h3>
              <template v-if="isDeletePage() != true">
                <v-btn v-can:add="'coupons'"
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/coupons/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </template>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="4">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search code / title / influencer ... "
                    color="#e60040"
                    hide-details="auto"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="coupon_status"
                    solo
                    hide-details="auto"
                    rounded
                    @click:clear="
                      (filter.status = null), (page = 1), getData()
                    "
                    v-model="filter.status"
                    :items="couponStatuses"
                    label="Coupon Status"
                    @input="(page = 1), getData()"
                    placeholder="Live / Scheduled / Expired"
                    prepend-inner-icon="mdi-ticket-percent"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    hide-details="auto"
                    rounded
                    @click:clear="
                      (filter.is_active = null), (page = 1), getData()
                    "
                    v-model="filter.is_active"
                    :items="statuses"
                    label="Status"
                    @input="(page = 1), getData()"
                    placeholder="Filter by Active Status"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="2">
                  <v-switch
                    class="mt-3"
                    hide-details="auto"
                    v-model="filter.is_influencer_coupon"
                    label="Influencer only"
                    @change="(page = 1), getData()"
                  ></v-switch>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 575px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="575"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left sr_no">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left" style="min-width: 140px">Code</th>
                      <th class="text-left" style="min-width: 160px">
                        Title / Influencer
                      </th>
                      <th class="text-left" style="min-width: 120px">
                        Discount
                      </th>
                      <th class="text-left" style="min-width: 110px">Used</th>
                      <th class="text-left" style="min-width: 200px">
                        Validity
                      </th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="coupons.length != 0">
                    <tr
                      v-for="(coupon, i) in coupons"
                      :key="`coupon_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': coupons.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ serialNoStarting + i + 1 }}
                      </td>
                      <td>
                        <v-chip
                          small
                          :color="couponState(coupon).color"
                          text-color="white"
                        >
                          <v-avatar left>
                            <v-icon size="15">{{
                              couponState(coupon).icon
                            }}</v-icon>
                          </v-avatar>
                          {{ couponState(coupon).label }}
                        </v-chip>
                      </td>
                      <td>
                        <strong>{{ coupon.code }}</strong>
                      </td>
                      <td>
                        {{ coupon.title || "-" }}
                        <div
                          v-if="coupon.influencer_name"
                          class="grey--text text--darken-1"
                          style="font-size: 12px"
                        >
                          <v-icon size="13">mdi-account-star</v-icon>
                          {{ coupon.influencer_name }}
                          <span v-if="coupon.influencer_platform">
                            ({{ coupon.influencer_platform }})</span
                          >
                        </div>
                      </td>
                      <td>
                        {{ discountLabel(coupon) }}
                        <div
                          v-if="
                            coupon.discount_type == 'percent' &&
                            coupon.max_discount_amount
                          "
                          class="grey--text text--darken-1"
                          style="font-size: 12px"
                        >
                          max &#8377;{{ coupon.max_discount_amount }}
                        </div>
                      </td>
                      <td>
                        {{ coupon.used_count || 0 }}
                        <span v-if="coupon.usage_limit">
                          / {{ coupon.usage_limit }}</span
                        >
                        <span v-else> / &#8734;</span>
                        <div
                          v-if="coupon.remaining_uses !== null"
                          class="grey--text text--darken-1"
                          style="font-size: 12px"
                        >
                          {{ coupon.remaining_uses }} left
                        </div>
                      </td>
                      <td style="min-width: 200px">
                        {{ formatDate(coupon.valid_from) || "-" }}
                        <span v-if="coupon.valid_till">
                          &rarr; {{ formatDate(coupon.valid_till) }}</span
                        >
                        <span v-else> &rarr; No expiry</span>
                      </td>
                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto mr-2"
                                color="success"
                                @click="copyShareLink(coupon)"
                              >
                                <v-icon dark> mdi-link-variant </v-icon>
                              </v-btn>
                            </template>
                            <span>Copy share link for the influencer</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="info"
                                :to="`/coupons/${encryptIt(coupon.id)}/usages`"
                              >
                                <v-icon dark> mdi-account-multiple </v-icon>
                              </v-btn>
                            </template>
                            <span>Who used this coupon</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'coupons'"
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="error"
                                @click="OpenWarning(coupon.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Coupon</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/coupons/${encryptIt(coupon.id)}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this Coupon</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'coupons'"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(coupon.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this Coupon</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="100" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-snackbar v-model="shareSnackbar" :timeout="4000" color="success" rounded="pill">
        {{ shareSnackbarText }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="shareSnackbar = false">Close</v-btn>
        </template>
      </v-snackbar>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_coupon" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Coupon deleted successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_deleted_coupon = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_coupon" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Coupon restored successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_restored_coupon = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Delete Warning Dialog Box -->
      <v-dialog v-model="deleteDialog" width="550px">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 150px"
                >
                  mdi-delete-alert
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Warning!</h1>
                      <br />
                      <h3>Are you sure you want to delete this?</h3>
                      <br />
                      <v-btn color="grey" dark @click="deleteDialog = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="red"
                        dark
                        class="ml-5"
                        @click="
                          Delete_this(to_be_deleted_id), (deleteDialog = false)
                        "
                        >Delete</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "CouponsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        status: "",
        is_influencer_coupon: false,
        show_deleted: false,
      },
      coupons: [],
      statuses: [
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      couponStatuses: [
        { id: "live", text: "LIVE", value: "live" },
        { id: "scheduled", text: "SCHEDULED", value: "scheduled" },
        { id: "expired", text: "EXPIRED", value: "expired" },
        { id: "exhausted", text: "LIMIT REACHED", value: "exhausted" },
      ],
      page: 1,
      serialNoStarting: 0,
      paginationLength: 0,
      count: 0,
      isLoading: false,
      is_deleted_coupon: false,
      is_restored_coupon: false,
      deleteDialog: false,
      to_be_deleted_id: "",
      shareSnackbar: false,
      shareSnackbarText: "",
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    formatDate(value) {
      if (!value) return "";
      try {
        const d = new Date(value);
        const pad = (n) => String(n).padStart(2, "0");
        return `${pad(d.getDate())}-${pad(
          d.getMonth() + 1
        )}-${d.getFullYear()}`;
      } catch (e) {
        return value;
      }
    },
    discountLabel(coupon) {
      if (coupon.discount_type === "fixed") {
        return `₹${coupon.discount_value} off`;
      }
      return `${coupon.discount_value}% off`;
    },
    // Live / Scheduled / Expired / Limit reached, worked out from the coupon row
    couponState(coupon) {
      if (!coupon.is_active) {
        return { label: "Inactive", color: "grey", icon: "mdi-close-circle" };
      }
      const now = new Date();
      if (coupon.valid_from && new Date(coupon.valid_from) > now) {
        return {
          label: "Scheduled",
          color: "blue",
          icon: "mdi-clock-outline",
        };
      }
      if (coupon.valid_till && new Date(coupon.valid_till) < now) {
        return { label: "Expired", color: "red", icon: "mdi-calendar-remove" };
      }
      if (
        coupon.usage_limit &&
        Number(coupon.used_count) >= Number(coupon.usage_limit)
      ) {
        return {
          label: "Limit reached",
          color: "orange darken-2",
          icon: "mdi-account-cancel",
        };
      }
      return {
        label: "Live",
        color: "teal",
        icon: "mdi-checkbox-marked-circle",
      };
    },
    async getData() {
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.isLoading = true;
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&status=" +
        (this.filter.status || "") +
        "&is_active=" +
        (this.filter.is_active || "") +
        "&search_keyword=" +
        (this.filter.search_keyword || "");
      if (this.filter.is_influencer_coupon) {
        query += "&is_influencer_coupon=1";
      }
      await axios
        .get(`coupons?${query}`)
        .then((response) => {
          this.coupons = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
      this.isLoading = false;
    },
    // Public landing page for a coupon: /c/CODE on the API host, not the admin SPA.
    // baseUrl is whatever src/axios.js set - the CI deploy writes that file from
    // DEPLOYMENT_CONFIG.basePath, so this follows the API host automatically.
    shareLink(coupon) {
      let base = (this.baseUrl || "").replace(/\/api\/?$/, "");
      if (!base) {
        base = process.env.VUE_APP_SHARE_BASE_URL || "";
      }
      base = base.replace(/\/+$/, "");

      // Codes are only unique per company, so pin the company down
      const companyId = this.company && this.company.id ? this.company.id : null;
      const query = companyId ? `?c=${companyId}` : "";

      return `${base}/c/${encodeURIComponent(coupon.code)}${query}`;
    },
    async copyShareLink(coupon) {
      const link = this.shareLink(coupon);

      try {
        // navigator.clipboard needs https or localhost, hence the fallback below
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(link);
        } else {
          const ta = document.createElement("textarea");
          ta.value = link;
          ta.style.position = "fixed";
          ta.style.opacity = "0";
          document.body.appendChild(ta);
          ta.select();
          document.execCommand("copy");
          document.body.removeChild(ta);
        }
        this.shareSnackbarText = `Link copied: ${link}`;
      } catch (error) {
        console.error(error);
        this.shareSnackbarText = link;
      }
      this.shareSnackbar = true;
    },
    OpenWarning(request_id) {
      this.to_be_deleted_id = request_id;
      this.deleteDialog = true;
    },
    async Delete_this(id) {
      await axios
        .post(`/coupons/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.is_deleted_coupon = true;
          this.getData();
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
    },
    async Restore_this(id) {
      await axios
        .post(`/coupons/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.is_restored_coupon = true;
          this.getData();
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
    },
  },
};
</script>
